import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import Cookies from 'js-cookie';

const Pagination = ({ pagination, data, onLoading, reactQuery }) => {
	const [total, setTotal] = useState();
	const test = useSelector((state) => state.main);

	const locale = Cookies.get('locale') ?? 'en';
	const isRTL = locale === 'ae';

	const handlePageChange = async (url) => {
		if (!url) return; // Do nothing if the URL is null (disabled button)

		if (reactQuery) {
			data(url);
		} else {
			onLoading && onLoading(true);
			if (Object.keys(test.user).length === 0) {
				const response = await api.paginationapiClient(url);
				if (response) {
					setTotal(response.data?.total);
					data(response.data);
					onLoading && onLoading(false);
				}
			} else {
				const response = await api.paginationapi(url);
				if (response) {
					setTotal(response.data?.total);
					data(response.data);
					onLoading && onLoading(false);
				}
			}
		}
	};

	const renderPageLink = (page) => {
		// The icons remain the same, but their container will be reversed using CSS
		return (
			page.label == '&laquo; Previous' ? (
				<>
					<li
						key={page.label}
						className={`paginate_button page-item previous ${page.active ? 'active' : ''}`}
					>
						<Link
							to={''}
							onClick={() => handlePageChange(page.url)}
							className={`page-link ${page.url ? '' : 'disabled'}`}
							style={{ marginTop: '2px' }}
						>
							<i className="fas fa-chevron-left"></i>
						</Link>
					</li>
				</>
			) : page.label == 'Next &raquo;' ? (
				<li
					key={page.label}
					className={`paginate_button page-item next ${page.active ? 'active' : ''}`}
					style={{ marginLeft: '-1px' }}
				>
					<Link
						to={''}
						onClick={() => handlePageChange(page.url)}
						className={`page-link ${page.url ? '' : 'disabled'}`}
						style={{ marginTop: '2px' }}
					>
						<i className="fas fa-chevron-right"></i>
					</Link>
				</li>
			) : (
				<></>
			)
		);
	};

	useEffect(() => {
		setTotal(pagination?.total);
		// setCurrentpage(pagination?.current_page);
	}, [pagination]); // Updated dependency array

	return (
		pagination?.total > 0 && pagination?.links?.length > 2 ? (
			<div className="d-flex align-items-center justify-content-center paginationcon">
				<div className="col-sm-12 col-md-6"></div>
				<div className="col-sm-12 col-md-6">
					<div style={{ display: 'flex', justifyContent: isRTL ? 'left' : 'right', alignItems: 'center', marginBottom: '-10px' }}>
						<div style={{ marginRight: isRTL ? '0' : '5px', marginLeft: isRTL ? '5px' : '0', whiteSpace: 'nowrap' }}>
							{pagination?.total?.toLocaleString() || total?.toLocaleString()} items &#183; {pagination?.from} to{' '}
							{pagination?.to}
						</div>
						<div className="dataTables_paginate paging_simple_numbers" id="DataTables_Table_0_paginate">
							<ul className="pagination justify-content-end mb-0" style={{ flexDirection: isRTL ? 'row-reverse' : 'row' }}>
								{pagination?.links?.map((page) => renderPageLink(page))}
							</ul>
						</div>
					</div>
				</div>
			</div>
		) : null
	);
};

export default Pagination;
